import { jsx as r } from "react/jsx-runtime";
import { createContext as i, useContext as s } from "react";
function u(o = null) {
  const t = i(o);
  return [({ children: e, value: n }) => /* @__PURE__ */ r(t.Provider, { value: n, children: e }), () => s(t)];
}
export {
  u as c
};
